import axios from "axios";
import lookups from "../forms/lookups";
import {
  addFailureNotification,
  addSuccessNotification,
  getServiceErrorMessage,
} from "./notifications";

const API = window.location.origin + "/api/";

export function Get(dispatch, method) {
  return axios
    .get(API + method)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);

      addFailureNotification(dispatch, error.message);

      return error;
    });
}

function Post(dispatch, method, successMessage, data, methodUrl) {
  return axios
    .post(API + method, data, {
      params: {
        methodUrl: methodUrl,
      },
    })
    .then(function (response) {
      if (successMessage) {
        addSuccessNotification(dispatch, successMessage);
      }

      return response;
    })
    .catch(function (error) {
      console.log(error);

      addFailureNotification(dispatch, getServiceErrorMessage(error));

      return error;
    });
}

export function CountCommunicationAudienceMembers(dispatch, request) {
  return Post(
    dispatch,
    "CountCommunicationAudienceMembers",
    "",
    request
  );
}

export function GetCommunicationAudienceMemberCount(dispatch, requestId) {
  return Get(dispatch, `GetCommunicationAudienceMemberCount?requestId=${requestId}`);
}

export function GetCommunicationPublishStatus(dispatch, communicationId) {
  return Get(dispatch, `GetCommunicationPublishStatus?communicationId=${communicationId}`);
}

export function GetCommunicationAudienceExportStatus(dispatch, requestId) {
  return Get(dispatch, `GetCommunicationAudienceExportStatus?requestId=${requestId}`);
}

export function ExportCommunicationAudienceToFile(
  dispatch,
  successMessage,
  communicationAudience
) {
  return Post(
    dispatch,
    "ExportCommunicationAudienceToFile",
    successMessage,
    communicationAudience
  );
}

export function ExportCommunicationAudienceToMarketingList(
  dispatch,
  successMessage,
  communicationAudience
) {
  return Post(
    dispatch,
    "ExportCommunicationAudienceToMarketingList",
    successMessage,
    communicationAudience
  );
}

export function GetAllEntityBasicInfo(
  dispatch,
  entityName,
  searchFilter
) {
  let url = `GetAllEntityBasicInfo?entityname=${entityName}`;

  if (searchFilter && searchFilter !== "") {
    // Append the searchfilter parameter to the URL
    url += `&searchfilter=${searchFilter}`;
  }

  return Get(dispatch, url);
}

export function GetMultipleEntityBasicInfo(
  dispatch,
  lookups,
  sourceEntityName = ""
) {
  let url = `GetMultipleEntityBasicInfo?entitynames=${lookups.map(
    (l) => l.entityName
  )}&searchfilters=${lookups.map((l) => l.searchFilter).join(",")}`;

  if (sourceEntityName) {
    url += `&sourceentityname=${sourceEntityName}`;
  }

  return Get(dispatch, url);
}

export function GetAllEntityDetailedInfo(
  dispatch,
  entityName,
  showInactiveRecords
) {
  let url = `GetAllEntityDetailedInfo?entityname=${entityName}&getinactiverecords=${showInactiveRecords}`;
  return Get(dispatch, url);
}

export function GetDefaultValuesForEntity(dispatch, entityName) {
  let url = `GetDefaultValuesForEntity?entityname=${entityName}`;
  return Get(dispatch, url);
}

export function GetEntityAttributes(dispatch, entityName) {
  let url = `GetEntityAttributes?entityname=${entityName}`;
  return Get(dispatch, url);
}

export function GetEntityAudits(dispatch, label, id) {
  let url = `GetEntityAudits?label=${label}&id=${id}`;
  return Get(dispatch, url);
}

export function GetBlacklistEntityAudits(dispatch) {
  return Get(dispatch, "GetBlacklistEntityAudits");
}

export function GetDataImportAvailableColumns(dispatch) {
  return Get(dispatch, "GetDataImportAvailableColumns");
}

export function GetContactCustomAttributeFields(dispatch) {
  return Get(dispatch, "GetContactCustomAttributeFields");
}

export function GetEntityAuditsByLoggingId(
  dispatch,
  label,
  loggingId
) {
  let url = `GetEntityAuditsByLoggingId?label=${label}&loggingid=${loggingId}`;
  return Get(dispatch, url);
}

export function GetEntityRecordById(dispatch, entityName, id) {
  let url = `GetEntityRecordById?entityname=${entityName}&id=${id}`;
  return Get(dispatch, url);
}

export function ActivateEmailMarketing(dispatch, customerId, code) {
  return Get(
    dispatch,
    `ActivateEmailMarketing?customerId=${customerId}&activationCode=${code}`
  );
}

export function GetCommunicationAudienceRules(dispatch, runAt) {
  return Get(
    dispatch,
    `GetCommunicationAudienceRules?runAt=${runAt}`
  );
}

export function GetCommunicationOptions(dispatch) {
  return Get(dispatch, `GetCommunicationOptions`);
}

export function GetCommunicationStatistics(
  dispatch,
  communicationId,
  useCloudStorage,
  returnEmailHtml
) {
  let url = `GetCommunicationStatistics?communicationId=${communicationId}&useCloudStorage=${useCloudStorage}&returnEmailHtml=${returnEmailHtml}`;
  return Get(dispatch, url);
}

export function GetInitialState(dispatch) {
  return Get(dispatch, "GetInitialState");
}

export function GetReport(dispatch, workspaceId, reportId) {
  let url = `GetReport?workspaceId=${workspaceId}&reportId=${reportId}`;
  return Get(dispatch, url);
}

export function IsBlacklisted(dispatch, emailAddress) {
  return Get(dispatch, `IsBlacklisted?emailAddress=${emailAddress}`);
}

export function IsExcluded(dispatch, emailAddress) {
  return Get(dispatch, `IsExcluded?emailAddress=${emailAddress}`);
}

export function RemoveFromMailExclusion(dispatch, emailAddress) {
  return Get(
    dispatch,
    `RemoveFromMailExclusion?emailAddress=${emailAddress}`
  );
}

export function ResendCommunicationActivity(
  dispatch,
  id,
  communicationId
) {
  return Get(
    dispatch,
    `ResendCommunicationActivity?id=${id}&communicationId=${communicationId}`
  );
}

export function StartCommunication(dispatch, id) {
  return Get(dispatch, `StartCommunication?id=${id}`);
}

export function StopCommunication(dispatch, id) {
  return Get(dispatch, `StopCommunication?id=${id}`);
}

export function UnpublishTriggerFlow(dispatch, id) {
  return Get(dispatch, `UnpublishTriggerFlow?id=${id}`);
}

export function Unsuppress(dispatch, emailAddress) {
  return Get(dispatch, `Unsuppress?emailAddress=${emailAddress}`);
}

export function Create(
  dispatch,
  successMessage,
  { Id, Name, Attributes },
  entityName,
  methodName
) {
  const method = methodName
    ? methodName
    : GetCreateMethod(entityName);
  ClearCache(entityName);
  // create or update the entity
  return Post(
    dispatch,
    "Create",
    successMessage,
    {
      Id,
      Name,
      Attributes,
    },
    method
  );
}

export function SaveView(
  dispatch,
  { AdvancedSearchNodes, EntityName, Fields, Filters, Id, Name }
) {
  return Post(dispatch, "saveview", "", {
    AdvancedSearchNodes,
    EntityName,
    Fields,
    Filters,
    Id,
    Name,
  });
}

export function RenameView(dispatch, { Id, Name }) {
  return Post(dispatch, "renameview", "", {
    Id,
    Name,
  });
}

export function DeleteView(dispatch, id) {
  return Get(dispatch, `deleteview?id=${id}`);
}

export function Search(
  dispatch,
  successMessage,
  {
    EntityName,
    Fields,
    Filters,
    IsAdvancedSearch,
    IsExport,
    AdvancedSearchJoins,
    AdvancedSearchNodes,
    MarketingListId,
    MarketingListName,
    RemoveFromMarketingList,
    ReplaceExistingListMembers,
    PageRequested,
    PageSize,
  }
) {
  // search for records
  const method = IsAdvancedSearch
    ? "advancedentitysearch"
    : "entitysearch";
  return Post(dispatch, method, successMessage, {
    EntityName,
    Fields,
    Filters,
    IsExport,
    AdvancedSearchJoins,
    AdvancedSearchNodes,
    MarketingListId,
    MarketingListName,
    RemoveFromMarketingList,
    ReplaceExistingListMembers,
    PageRequested,
    PageSize,
  });
}

export function BulkEdit(dispatch, entityName, records) {
  ClearCache(entityName);
  return Post(dispatch, "bulkedit", "Records updated", {
    EntityName: entityName,
    Records: records,
  });
}

export function GetDataImportStatus(dispatch, importId) {
  return Get(dispatch, `GetDataImportStatus?importId=${importId}`);
}

export function Update(
  dispatch,
  successMessage,
  { Id, Name, Attributes },
  entityName,
  methodName
) {
  const method = methodName
    ? methodName
    : GetUpdateMethod(entityName);
  ClearCache(entityName);
  // create or update the entity
  return Post(
    dispatch,
    "Update",
    successMessage,
    {
      Id,
      Name,
      Attributes,
    },
    method
  );
}

export function Delete(dispatch, id, entityName, methodName) {
  ClearCache(entityName);
  if (entityName === "list") {
    return Post(
      dispatch,
      "DeleteMarketingList",
      "Record successfully deleted",
      { Id: id }
    );
  } else {
    const method = methodName
      ? methodName
      : GetDeleteMethod(entityName);
    return Post(
      dispatch,
      "delete",
      "Record successfully deleted",
      { Id: id },
      method
    );
  }
}

export function SetRecordState(
  dispatch,
  { Ids, EntityName, StateCode }
) {
  ClearCache(EntityName);
  // update the status for the given records in the entity
  return Post(
    dispatch,
    "SetRecordState",
    StateCode === 0
      ? "Records successfully activated"
      : "Records successfully deactivated",
    {
      Ids,
      EntityName,
      StateCode,
    }
  );
}

export function ClearCache(entityName) {
  // clear the cache for the entity and its active and inactive records
  sessionStorage.removeItem(entityName);
  sessionStorage.removeItem(entityName + "-Active");
  sessionStorage.removeItem(entityName + "-Inactive");

  // clear the cache for the lookups
  const entityLookups = lookups[entityName];
  if (entityLookups) {
    for (const [key, lookup] of Object.entries(entityLookups)) {
      console.log(
        "Removing lookup from session storage.",
        `${key}: ${lookup.name}`
      );
      sessionStorage.removeItem(lookup.name);
    }
  }
}

export function GetCreateMethod(entityName) {
  switch (entityName) {
    case "dwautomation":
      return "entity/createentityrecord?entityName=dwautomation";
    case "dwcompetition":
      return "entity/createentityrecord?entityName=dwcompetition";
    case "dwcompetitionstage":
      return "entity/createentityrecord?entityName=dwcompetitionstage";
    case "dwdatamodel":
      return "entity/createentityrecord?entityName=dwdatamodel";
    case "dweventprofile":
      return "entity/createentityrecord?entityName=dweventprofile";
    case "dwfixture":
      return "entity/createentityrecord?entityName=dwfixture";
    case "dwfixturegrade":
      return "entity/createentityrecord?entityName=dwfixturegrade";
    case "dwhomestatus":
      return "entity/createentityrecord?entityName=dwhomestatus";
    case "dwopponent":
      return "entity/createentityrecord?entityName=dwopponent";
    case "dwopponenttype":
      return "entity/createentityrecord?entityName=dwopponenttype";
    case "dwseason":
      return "entity/createentityrecord?entityName=dwseason";
    case "dwseasonalperiod":
      return "entity/createentityrecord?entityName=dwseasonalperiod";
    case "dwteam":
      return "entity/createentityrecord?entityName=dwteam";
    case "dwtype":
      return "entity/createentityrecord?entityName=dwtype";
    case "account":
      return "ticketing/createaccount";
    case "campaign":
      return "ticketing/createcampaign";
    case "contact":
      return "ticketing/createcontact";
    case "customeraddress":
      return "ticketing/createcustomeraddress";
    case "dataimport":
      return "data-import/start-import";
    case "g4c_abtest":
      return "email-marketing/create-abtest";
    case "g4c_communication":
      return "email-marketing/create-communication";
    case "g4c_communicationaudience":
      return "email-marketing/create-communication-audience";
    case "g4c_communicationoptions":
      return "email-marketing/createcommunicationoptions";
    case "g4c_communicationsavedlayout":
      return "email-marketing/savecommunicationdesignaslayout";
    case "g4c_subscriptiongroup":
      return "ticketing/createsubscriptiongroup";
    case "g4c_triggerflow":
      return "email-marketing/create-trigger-flow";
    case "list":
      return "ticketing/createmarketinglist";
    case "warehouse-application":
      return "configuration/warehouse-applications";
    default:
      throw new Error("No create method found for entity");
  }
}

export function GetUpdateMethod(entityName) {
  switch (entityName) {
    case "dwautomation":
      return "entity/updateentityrecord?entityName=dwautomation";
    case "dwcompetition":
      return "entity/updateentityrecord?entityName=dwcompetition";
    case "dwcompetitionstage":
      return "entity/updateentityrecord?entityName=dwcompetitionstage";
    case "dwdatamodel":
      return "entity/updateentityrecord?entityName=dwdatamodel";
    case "dweventprofile":
      return "entity/updateentityrecord?entityName=dweventprofile";
    case "dwfixture":
      return "entity/updateentityrecord?entityName=dwfixture";
    case "dwfixturegrade":
      return "entity/updateentityrecord?entityName=dwfixturegrade";
    case "dwhomestatus":
      return "entity/updateentityrecord?entityName=dwhomestatus";
    case "dwopponent":
      return "entity/updateentityrecord?entityName=dwopponent";
    case "dwopponenttype":
      return "entity/updateentityrecord?entityName=dwopponenttype";
    case "dwseason":
      return "entity/updateentityrecord?entityName=dwseason";
    case "dwseasonalperiod":
      return "entity/updateentityrecord?entityName=dwseasonalperiod";
    case "dwteam":
      return "entity/updateentityrecord?entityName=dwteam";
    case "dwtickethospitalityproduct":
      return "entity/updateentityrecord?entityName=dwtickethospitalityproduct";
    case "dwtype":
      return "entity/updateentityrecord?entityName=dwtype";
    case "account":
      return "ticketing/updateaccount";
    case "campaign":
      return "ticketing/updatecampaign";
    case "contact":
      return "ticketing/updatecontact";
    case "customeraddress":
      return "ticketing/updatecustomeraddress";
    case "g4c_abtest":
      return "email-marketing/update-abtest";
    case "g4c_communication":
      return "email-marketing/update-communication";
    case "g4c_communicationaudience":
      return "email-marketing/update-communication-audience";
    case "g4c_communicationoptions":
      return "email-marketing/updatecommunicationoptions";
    case "g4c_communicationsavedlayout":
      return "email-marketing/updatesavedcommunicationlayout";
    case "g4c_subscriptiongroup":
      return "ticketing/updatesubscriptiongroup";
    case "g4c_triggerflow":
      return `email-marketing/update-trigger-flow`;
    case "list":
      return "ticketing/updatemarketinglist";
    case "warehouse-application":
      return "configuration/warehouse-applications";
    default:
      throw new Error("No update method found for entity");
  }
}

export function GetDeleteMethod(entityName) {
  switch (entityName) {
    case "dwcompetition":
      return "entity/deleteentityrecord?entityName=dwcompetition";
    case "dwcompetitionstage":
      return "entity/deleteentityrecord?entityName=dwcompetitionstage";
    case "dwdatamodel":
      return "entity/deleteentityrecord?entityName=dwdatamodel";
    case "dweventprofile":
      return "entity/deleteentityrecord?entityName=dweventprofile";
    case "dwfixture":
      return "entity/deleteentityrecord?entityName=dwfixture";
    case "dwfixturegrade":
      return "entity/deleteentityrecord?entityName=dwfixturegrade";
    case "dwhomestatus":
      return "entity/deleteentityrecord?entityName=dwhomestatus";
    case "dwopponent":
      return "entity/deleteentityrecord?entityName=dwopponent";
    case "dwopponenttype":
      return "entity/deleteentityrecord?entityName=dwopponenttype";
    case "dwseason":
      return "entity/deleteentityrecord?entityName=dwseason";
    case "dwseasonalperiod":
      return "entity/deleteentityrecord?entityName=dwseasonalperiod";
    case "dwteam":
      return "entity/deleteentityrecord?entityName=dwteam";
    case "dwtype":
      return "entity/deleteentityrecord?entityName=dwtype";
    default:
      throw new Error("No delete method found for entity");
  }
}
